module.exports = __webpack_public_path__ + "img/ir.2cd89129.svg";